import { MovementOperation } from "../../enums/movements/movement-operation";
import { LocationFinishDTO } from "./location-finishDTO";

export class ExecuteOperationDTO {
    movementPlanId: number;
	movementId: number;
	operation: MovementOperation
	locationFinish?: LocationFinishDTO
}